<p-dialog
  *ngIf="visible"
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="true"
  [baseZIndex]="10000"
  (onHide)="close.emit()"
  [styleClass]="'p-success-dialog'"
>
  <div class="text-center success-modal-content">
    <div class="icon-container mx-auto mb-4">
      <img src="assets/svg/like.svg" alt="Success Icon" />
    </div>
    <div class="title mb-2">{{ title }}</div>
    <div class="subtitle">{{ message }}</div>
    <button pButton type="button" class="action-btn" (click)="close.emit()">
      {{ closeLabel }}
    </button>
  </div>
</p-dialog>
